export default __webpack_public_path__ + "static/media/Fervent Atlantean Relic.155780de.jpg";